import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog'
import { useEffect, useState } from 'react'
import { PetrolimexLogService } from '../../danh-muc/danh-sach-giao-dich-xang-dau/PetrolimexLogService';

export const DialogQrCode = ({ display, setDisplay, selectedItems }) => {
  const [html, setHtml] = useState('')
  useEffect(() => {
    if (display) {
      PetrolimexLogService.printPaymentLog({ id: selectedItems.id }).then((data) => setHtml(data.masterPage))
    }
  }, [selectedItems, display])
  const footer = (
    <div>
      <Button label="Đóng" onClick={() => setDisplay(null)} className="p-button-outlined p-button-secondary p-button-sm" />
    </div>
  );

  return (
    <Dialog header={`Thông tin giao dịch`} footer={footer} visible={!!display} style={{ width: '60rem' }} position="top" onHide={() => setDisplay(null)}>
      <iframe title="template-preview" className='w-full' style={{ height: '50rem' }} srcDoc={html} />
    </Dialog>
  )
}